import React from 'react';

type IColumnSelectorOptionContext = { selected?: any; isNumeric?: boolean; enabled?: boolean; option?: any };

const ColumnSelectorOptionContext = React.createContext({} as IColumnSelectorOptionContext);
export default ColumnSelectorOptionContext;
